// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"319":"4bed66ba515a2d38","496":"83edc8afc0370428","505":"29fd7b60e077b9c6"}[chunkId] + ".js";
};